import React, { useCallback } from "react";
import { Row, Col } from "react-bootstrap";
import { CAMPOS_WHATSAPP_LISTA_ESPERA, usePuedeCrearPlantillas } from "./recordatorios";
import CanalWhatsapp, { CanalEmail, CanalPush } from "./CanalWhatsapp";

/* Waitlist block of the three verticals' policy forms (Beauty, courts, tables), after the review request. It sits in a
   full-width column of the form's Row. `lista` is the form value `{ enabled, whatsapp }` (listaEsperaDeVenue) and
   `onChange(lista)` receives the whole updated value. The WhatsApp channel has its own workspace and template and offers
   the link to claim the freed slot as template data.
   `onAntesDeIrAChat` runs when the Zoco Chat link is clicked, so the form can keep its unsaved edits (borradorPoliticas). */

const ListaEsperaAjustes = ({ lista, onChange, local, errorWhatsapp, onAntesDeIrAChat, volver }) => {
  const puedeCrear = usePuedeCrearPlantillas();
  const { enabled, whatsapp, push } = lista;
  const cambiarWhatsapp = useCallback((wa) => onChange({ ...lista, whatsapp: wa }), [onChange, lista]);

  return (
    <Row className="g-4">
      <Col md={12}>
        <div className="zr-field">
          <span className="zr-field__label">Lista de espera</span>
          <input
            type="checkbox"
            className="zr-switch"
            aria-label="Lista de espera"
            checked={Boolean(enabled)}
            onChange={() => onChange({ ...lista, enabled: !enabled })}
          />
          <small style={{ color: "#6b7280", fontSize: 12 }}>
            Cuando un día está lleno, tus clientes se anotan y les avisamos si se libera un horario. Gana el primero que reserva.
          </small>
        </div>
      </Col>
      {enabled && (
        <Col md={12}>
          <div className="zr-field">
            <span id="lista-canales-label" className="zr-field__label">Canales del aviso de la lista de espera</span>
            <div className="rwa-canales" role="group" aria-labelledby="lista-canales-label">
              <CanalEmail texto="Le llega al email que el cliente dejó al anotarse, si dejó uno." />
              <CanalWhatsapp
                whatsapp={whatsapp}
                onChange={cambiarWhatsapp}
                local={local}
                error={errorWhatsapp}
                puedeCrear={puedeCrear}
                onAntesDeIrAChat={onAntesDeIrAChat}
                volver={volver}
                campos={CAMPOS_WHATSAPP_LISTA_ESPERA}
                idBase="rwa-lista"
                etiqueta="Aviso de lista de espera por WhatsApp"
                pedido="lista"
              />
              <CanalPush push={push} onChange={(p) => onChange({ ...lista, push: p })} etiqueta="Aviso de lista de espera por notificación en la app" tipo="waitlist" />
            </div>
          </div>
        </Col>
      )}
    </Row>
  );
};

export default ListaEsperaAjustes;
